import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const AGENTS_SLICE_FEATURE_KEY = 'agentsSlice';

export interface Agent {
  aiworker_id: string;
  name: string;
  description: string;
  status: string;
  category: string;
  type: string;
  sub_type: string;
  created_by: string;
  updated_by: string;
  created_at: string;
  updated_at: string;
  is_public: boolean;
  is_default: boolean;
  aiworkers_attrs: any[];
}

export interface AgentsState {
  agents: Agent[];
}

const initialState: AgentsState = {
  agents: []
};

export const agentsSlice = createSlice({
  name: AGENTS_SLICE_FEATURE_KEY,
  initialState,
  reducers: {
    updateAgentsData: (state, action: PayloadAction<Agent[]>) => {
      state.agents = action.payload;
    }
  }
});

export const { updateAgentsData } = agentsSlice.actions;

export default agentsSlice.reducer; 